import { DecimalPipe, getCurrencySymbol, NgIf, AsyncPipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { RootState } from '@next/core-lib/app';
import { LocaleService, TranslatePipe } from '@next/core-lib/i18n';
import { SelectedCustomer, SelectedLocation, UserSelectors } from '@next/core-lib/user';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { Calculation, ExtendedSimulationData } from '../../../models/feed-profit.model';

@Component({
  selector: 'app-extended-simulation-report',
  templateUrl: './extended-simulation-report.component.html',
  styleUrls: ['./extended-simulation-report.component.scss'],
  imports: [NgIf, AsyncPipe, TranslatePipe],
})
export class ExtendedSimulationReportComponent implements OnInit {
  @Input() extendedSimulationData: ExtendedSimulationData;
  @Input() calculation: Calculation;

  customer$: Observable<SelectedCustomer> = this.store.select(UserSelectors.selectCustomer);
  location$: Observable<SelectedLocation> = this.store.select(UserSelectors.selectLocation);
  currencySymbol: string;

  constructor(
    private readonly store: Store<RootState>,
    private readonly localeService: LocaleService,
    private readonly decimalPipe: DecimalPipe,
  ) {}

  ngOnInit() {
    this.currencySymbol = getCurrencySymbol(
      this.localeService.getCustomerCurrencySymbol(),
      'narrow',
    );
  }

  getSummaryValue(value: number, digitsInfo = '1.0-2') {
    if (value === undefined || value === null || isNaN(value) || !isFinite(value)) {
      return this.localeService.translate('-');
    }
    return this.decimalPipe.transform(value, digitsInfo, this.localeService.getLocale());
  }
}
